import React, { Component } from "react";
import classnames from "classnames";

import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button } from "../common/Button";
import * as styles from "./SidebarTabsButton.scss";

export interface ISidebarTabsButtonProps {
    index: number;
    name: string;
    active: boolean;
    icon?: IconName;
    onActivateTab: (index: number) => void;
}

export class SidebarTabsButton extends Component<ISidebarTabsButtonProps> {
    public render() {
        const { name, icon, active } = this.props;

        return (
            <Button
                className={classnames(
                    styles["sidebar-tabs-button"],
                    styles.button,
                    active && styles.active,
                )}
                onClicked={this.onActivateTab}
            >
                <div
                    data-testid={`sidebar-button-${name}`}
                    className={styles["button-inner"]}
                >
                    {icon && (
                        <Icon
                            className={styles["icon-label"]}
                            size="18"
                            color="#00E4FF"
                            name={icon}
                        />
                    )}
                    {name}
                </div>
            </Button>
        );
    }

    private onActivateTab = () => {
        this.props.onActivateTab(this.props.index);
    };
}
